/**
 * @fileoverview The "how much?" box. Shows the city's currency sign in front
 * of the amount so nobody types shekels thinking in dollars.
 */
import React from 'react'
import PropTypes from 'prop-types'
import TextField from '@material-ui/core/TextField'
import InputAdornment from '@material-ui/core/InputAdornment'

const HoldAmountInput = ({
  value,
  onChange,
  error,
  disabled,
  autoFocus,
  money,
  label,
}) => (
  <TextField
    label={label}
    value={value}
    onChange={event => onChange(event.target.value)}
    error={Boolean(error)}
    helperText={error || ' '}
    disabled={disabled}
    autoFocus={autoFocus}
    fullWidth
    variant="outlined"
    margin="dense"
    inputProps={{ inputMode: 'decimal', 'aria-label': label }}
    InputProps={{
      startAdornment: money.currencySign ? (
        <InputAdornment position="start">{money.currencySign}</InputAdornment>
      ) : null,
      endAdornment:
        !money.currencySign && money.currency ? (
          <InputAdornment position="end">{money.currency}</InputAdornment>
        ) : null,
    }}
  />
)

HoldAmountInput.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.string,
  disabled: PropTypes.bool,
  autoFocus: PropTypes.bool,
  money: PropTypes.shape({
    currencySign: PropTypes.string,
    currency: PropTypes.string,
  }),
  label: PropTypes.string,
}

HoldAmountInput.defaultProps = {
  error: null,
  disabled: false,
  autoFocus: true,
  money: {},
  label: 'Hold amount',
}

export default HoldAmountInput
